import type {InterfaceStrings} from './strings'

export const ar: InterfaceStrings = {
    nav: {
        beginSession: 'ابدأ',
        faq: 'أسئلة شائعة',
        pricing: 'الأسعار',
        legal: 'معلومات قانونية',
        signIn: 'تسجيل الدخول',
        viewPricing: 'عرض الأسعار',
        signOut: 'تسجيل الخروج',
        account: 'الحساب',
        menu: 'القائمة',
        closeMenu: 'إغلاق القائمة',
        mainNav: 'التنقل الرئيسي',
        sessions: {
            zero: 'لا جلسات',
            one: 'جلسة واحدة',
            two: 'جلستان',
            few: '{n} جلسات',
            many: '{n} جلسة',
            other: '{n} جلسة',
        },
    },
    footer: {
        selfHypnosisFor: 'التنويم الذاتي من أجل',
        anxiety: 'القلق',
        sleep: 'النوم',
        stress: 'التوتر',
        confidence: 'الثقة بالنفس',
        focus: 'التركيز',
        learn: 'فهم المنهج',
        ericksonian: 'ما هو التنويم الإريكسوني',
        aiHow: 'كيف يعمل التنويم بالذكاء الاصطناعي',
        vsMeditation: 'التنويم أم التأمل',
        methods: 'تقنيات',
        languages: 'اللغات',
    },
    page: {
        cta: 'ابدأ جلستك المجانية',
        hint: 'جلستك الأولى مجانية',
        exploreFurther: 'للمزيد',
        disclaimer:
            'Quies أداة للعافية تساعد على الاسترخاء واستكشاف الذات. ليست جهازًا طبيًا، ولا تشخّص أي حالة أو تعالجها أو تشفيها. إن كنت تمر بأزمة نفسية، فتواصل مع مختص مؤهل.',
        transcript: 'النص',
        transcriptNote: 'مقتطف من جلسة حقيقية في Quies، كما قيلت.',
        breadcrumb: 'مسار التنقل',
    },
    pricing: {
        selectPlan: 'اختر هذه الباقة',
        subscribe: 'اشترك',
        perMonth: 'شهريًا',
        manageSubscription: 'إدارة الاشتراك',
        replayFree: 'إعادة الاستماع إلى جلسة سابقة مجانية دائمًا.',
        offerLead: 'تبدأ كل جلسة من حيث انتهت الجلسة السابقة.',
    },
    session: {
        chooseLanguage: 'اختر لغتك',
        changeLanguage: 'تغيير اللغة',
        changeVoice: 'تغيير الصوت',
        previewVoice: 'استمع إلى {voice}',
        stopPreview: 'إيقاف العيّنة',
        continue: 'متابعة',
        composing: 'Quies يكتب جلستك',
        preparing: 'يجري تحضير تأملك',
        pickingUp: 'نكمل من حيث توقفت',
        today: 'اليوم',
        yesterday: 'أمس',
        loading: 'جارٍ التحميل…',
        showEarlier: 'عرض الأقدم ({count})',
        tryDifferentApproach: 'جرّب طريقًا آخر',
        nothingAdded: 'دون إضافة',
        purchaseConfirmed: 'تم تأكيد الشراء',
        firstSessionNote: 'جلستك الأولى مجانية. ستسجّل الدخول قبل أن تستمع إليها.',
    },
    threshold: {
        title: 'سجّل الدخول لتستمع',
        message: 'جلستك الأولى مجانية. لا حاجة إلى بطاقة.',
        google: 'المتابعة عبر Google',
        sendLink: 'أرسل لي رابط الدخول',
        sending: 'جارٍ الإرسال…',
        emailLabel: 'البريد الإلكتروني',
        or: 'أو',
        waitingTitle: 'تحقّق من بريدك الإلكتروني',
        waitingBody: 'أرسلنا رابط تسجيل الدخول إلى {email}.',
        sendAgain: 'أرسل مرة أخرى',
        googleInstead: 'سجّل الدخول عبر Google بدلًا من ذلك',
        codeLabel: 'أو اكتب الرمز المكوّن من 6 أرقام من البريد الإلكتروني',
        codeSubmit: 'متابعة',
        codeSubmitting: 'جارٍ التحقق…',
        codeWrong: 'هذا الرمز غير صحيح.',
        codeDead: 'لم يعد هذا الرمز صالحًا. استخدم الرابط الموجود في البريد، أو أرسل رسالة جديدة.',
        errors: {
            invalidEmail: 'أدخل بريدًا إلكترونيًا صحيحًا.',
            rateLimited: 'محاولات كثيرة جدًا. أعد المحاولة بعد بضع دقائق.',
            sessionError: 'حدثت مشكلة في تسجيل الدخول. حدّث الصفحة وأعد المحاولة.',
            sendFailed: 'تعذّر إرسال البريد. أعد المحاولة.',
            sessionExpired: 'انتهت صلاحية تسجيل الدخول. حدّث الصفحة وأعد المحاولة.',
            generic: 'حدث خطأ. أعد المحاولة.',
        },
    },
    player: {
        play: 'تشغيل',
        pause: 'إيقاف مؤقت',
        playAgain: 'الاستماع مجددًا',
        seek: 'الموضع',
        eyesClosed: 'عينان مغمضتان',
        openEyes: 'افتح عينيك',
        paused: 'متوقف مؤقتًا',
        unavailable: 'الصوت غير متاح',
        untitled: 'جلسة Quies',
    },
    failure: {
        turnFailed: 'حدث خطأ من جهتنا. إجابتك محفوظة.',
        reconnecting: 'جارٍ إعادة الاتصال…',
        refusalTitle: 'لنسلك طريقًا آخر',
        refusal: 'تعذّر الرد على جزء من رسالتك. أعد صياغتها، أو أرسلها مرة أخرى.',
        openElsewhere: 'هذه الجلسة مفتوحة أيضًا في نافذة أخرى.',
        serviceDown: 'يتعذّر الوصول إلى Quies الآن. لم يضع شيء مما فعلته.',
        sessionsUsedTitle: 'لقد استخدمت جلساتك',
        voiceFailedTitle: 'تأملك مكتوب',
        voiceFailed: 'تعذّر تسجيل صوته الآن. لم يضع شيء، وإعادة تسجيله مجانية.',
        voiceStopped: 'توقف الصوت في منتصف الطريق. يمكنه أن يكمل من حيث توقف.',
        streamMissing: 'تأملك جاهز، لكنه لم يصل إلى هذه الصفحة.',
        tapToListen: 'المس للاستماع',
        fileFailed: 'تعذّر تشغيل هذا التسجيل. يمكن إعادة تسجيل التأمل صوتيًا دون مقابل.',
        recordingGone: 'لم يعد هذا التسجيل محفوظًا.',
        purchaseCancelled: 'أُلغي الشراء. لم يُخصم أي مبلغ.',
        purchasePending: 'تم تأكيد دفعتك. تستغرق جلساتك وقتًا أطول من المعتاد للوصول.',
        checkoutFailed: 'تعذّر إتمام الدفع. لم يُخصم أي مبلغ.',
        sessionEnded: 'بلغت هذه الجلسة نهايتها.',
        busy: 'الطلب على Quies كبير الآن. إجابتك محفوظة؛ حاول مجددًا بعد دقيقة.',
        tooLong: 'أصبحت هذه الجلسة أطول مما يستطيع Quies استيعابه. وقد أُعيدت إليك.',
        notSaved: 'تعذّر حفظ هذه الخطوة. حاول مجددًا لتتابع من حيث أنت.',
        meditationRefused:
            'تعذّرت كتابة هذا التأمل كما طُلب. أعد الصياغة، أو ابدأ من جديد: ستُعاد إليك هذه الجلسة.',
        meditationRefusedUncharged: 'تعذّرت كتابة هذا التأمل كما طُلب. أعد الصياغة، أو ابدأ من جديد.',
        linkExpired: 'انتهت صلاحية رابط تسجيل الدخول. اطلب رابطًا جديدًا.',
        oauthFailed: 'انقطع تسجيل الدخول. يُرجى المحاولة مجددًا.',
        offline: 'أنت غير متصل. ستُرسل إجابتك فور عودة الاتصال.',
        voiceChanged: 'لم يعد صوتك المختار متاحًا؛ سيقرأ هذا التأمل صوت آخر.',
        voiceReturned: 'ما زال تسجيل الصوت متعذرًا. أُعيدت إليك هذه الجلسة.',
        voiceFailedAgain: 'ما زال تسجيل الصوت متعذرًا.',
        voiceResuming: 'يُستأنف الصوت…',
        voiceLimited: 'سُجّلت لك عدة تأملات صوتيًا خلال هذه الساعة. حاول مجددًا بعد قليل.',
        tryAgain: 'حاول مجددًا',
        rephrase: 'أعد الصياغة',
        resume: 'استئناف',
        voiceAgain: 'أعد التسجيل الصوتي',
        listen: 'استمع',
        continue: 'متابعة',
        begin: 'ابدأ جلسة',
        signIn: 'تسجيل الدخول',
        checkAgain: 'تحقّق مجددًا',
        sendLink: 'أرسل رابط الدخول',
        useEmail: 'استخدم البريد الإلكتروني',
    },
}
